import React, { Component } from "react";
import { connect } from "react-redux";
import { FooterButtons } from "../../../../PickerOrder/PickerOrderPage/PickerOrderPage.styled";
import { FiPackage } from "react-icons/fi";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { BsFillExclamationTriangleFill } from "react-icons/bs";

export class PickerMenu extends Component {
  render() {
    let {
      serviceLoading,
      missingMedData,
      toggleIssueModal,
      handlePicked,
      handleAddBox,
      selectedMedRacks,
    } = this.props;
    return (
      <FooterButtons>
        <button
          className="bbtn addbox"
          onClick={() => {
            handleAddBox();
          }}
        >
          <FiPackage />
        </button>

        <button
          className="bbtn warn"
          disabled={serviceLoading}
          onClick={() => {
            toggleIssueModal(true);
          }}
        >
          <BsFillExclamationTriangleFill /> Issue
        </button>

        <button
          className="bbtn success"
          onClick={() => handlePicked()}
          disabled={
            missingMedData?.length > 0 ||
            serviceLoading ||
            selectedMedRacks?.remainingQuantity != 0
          }
        >
          <IoCheckmarkDoneCircleSharp /> Pick
        </button>
      </FooterButtons>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PickerMenu);
